"use strict";

// module Unsafe.Coerce

exports.unsafeCoerce = function (x) {
  return x;
};



//////////////////
// WEBPACK FOOTER
// ./output/Unsafe.Coerce/foreign.js
// module id = 310
// module chunks = 0